const en = {
  translation: {
    logo: {
      tagline: 'Cleaning services'
    },
    nav: {
      home: 'Home',
      services: 'Rates',
      booking: 'Book Online',
      myBookings: 'My Bookings',
      admin: 'Admin',
      profile: 'My Profile',
      login: 'Login',
      logout: 'Logout',
      contact: 'Contact'
      ,availability: 'My Availability'
    },
    hero: {
      title: 'A spotless home, without lifting a finger.',
      subtitle: 'Professional cleaning service for your peace of mind',
      cta: 'Book Now'
    },
    home: {
      whyChoose: 'Why Choose Tout Propre?',
      professionalTeam: 'Professional Team',
      professionalTeamDesc: 'Verified and insured cleaning experts',
      transparentPricing: 'Transparent Pricing',
      transparentPricingDesc: 'No hidden fees, instant quotes',
      flexibleScheduling: 'Flexible Scheduling',
      flexibleSchedulingDesc: 'Book at your convenience',
      qualityGuarantee: 'Quality Guarantee',
      qualityGuaranteeDesc: '48-hour satisfaction guarantee',
      howItWorks: 'How It Works',
      browseServices: 'View Rates',
      browseServicesDesc: 'View our rates and customize your cleaning',
      chooseDateTime: 'Select Date & Time',
      chooseDateTimeDesc: 'Pick the date and time that works best for you',
      getConfirmed: 'Get Confirmed',
      getConfirmedDesc: 'Our team confirms and arrives on time with all supplies',
      enjoyCleanliness: 'Enjoy Cleanliness',
      enjoyCleanlinessDesc: 'Relax while we make your home impeccable',
      testimonials: 'What Our Clients Say',
      testimonialOne: 'Excellent service! My home has never looked better. Highly recommend!',
      testimonialTwo: 'Professional, reliable, and affordable. Exactly what we needed!',
      testimonialThree: 'The ease of online booking and the quality of work are outstanding!',
      livingRoomAlt: 'Spotless modern living room',
      livingRoomTeamAlt: 'Professional cleaning team in a modern living room',
      kitchenAlt: 'Bright and clean modern kitchen',
      kitchenTeamAlt: 'Professional cleaning team in a bright kitchen',
      bedroomAlt: 'Freshly cleaned peaceful bedroom',
      bedroomTeamAlt: 'Professional cleaning team making a bedroom spotless'
    },
    services: {
      title: 'Rates',
      regular: 'Regular Cleaning',
      regularDesc: 'Routine maintenance for your home',
      deepCleaning: 'Deep Cleaning',
      deepDesc: 'Thorough cleaning of every corner',
      moveOut: 'Move-Out Cleaning',
      moveOutDesc: 'Complete cleaning for moving in or out',
      priceFrom: 'From',
      selectService: 'Select Service',
      customizeCleaning: 'Customize your cleaning',
      estimatedDuration: 'Estimated duration: {{hours}}h {{minutes}}min',
      bookConfigured: 'Book',
      pricingSummary: 'Residential pricing',
      baseCleaning: 'Base cleaning',
      baseCleaningIncludes: 'Starting price with included quantities',
      includedQuantity: '{{count}} included',
      includedInBase: '{{count}} included in the base cleaning',
      configureAndBook: 'Configure and book',
      backToServices: 'Back to services',
      configurationEyebrow: 'Customize your service',
      configurationInstructions: 'Simply adjust each quantity. Price and duration update automatically.',
      roomOrOption: 'Room or option',
      quantity: 'Quantity',
      decreaseQuantity: 'Decrease quantity',
      increaseQuantity: 'Increase quantity',
      yourCleaning: 'Your cleaning',
      totalPrice: 'Total price',
      totalDuration: 'Estimated duration',
      chooseDate: 'Choose date and time',
      totalUpdatesAutomatically: 'Availability will be calculated using this duration.',
      repeatCleanings: 'Repeat cleanings',
      frequency: 'Frequency',
      discount: 'Discount',
      within30Days: 'New booking within 30 days',
      within15Days: 'New booking within 15 days',
      weekly: 'New booking within 7 days',
      discountAutomatic: 'The best eligible discount is applied automatically based on your previous booking.',
      loadError: 'Failed to load services'
    },
    booking: {
      title: 'Book a Service',
      editTitle: 'Edit Booking',
      edit: 'Edit Booking',
      updateBooking: 'Save Booking Changes',
      updateSuccess: 'Booking updated successfully!',
      cannotEdit: 'This booking can no longer be edited',
      cancelBooking: 'Cancel Booking',
      cancelConfirm: 'Are you sure you want to cancel this booking?',
      cancelSuccess: 'Booking cancelled successfully',
      cancelError: 'Failed to cancel booking',
      selectService: 'Select Service',
      selectDate: 'Select Date',
      selectTime: 'Select Time',
      cleaningAddress: 'Complete Cleaning Address',
      street: 'Street address',
      unit: 'Apartment / Unit (optional)',
      unitRequired: 'Apartment / Unit / Address complement',
      city: 'City',
      province: 'Province',
      postalCode: 'Postal code',
      notes: 'Additional Notes',
      notesPlaceholder: 'Any special requests?',
      requiredFields: 'Please fill in all required fields',
      createError: 'Failed to create booking',
      availabilityError: 'Failed to load availability',
      chooseServiceAndDate: 'Choose a service and date to see available times.',
      chooseServiceFirst: 'Choose a service to view the available dates.',
      available: 'Available',
      unavailable: 'Unavailable',
      scheduleClosed: 'No service hours are available on this day.',
      remainingCapacity: '{{remaining}} of {{capacity}} spots available',
      noBookings: 'No bookings yet.',
      bookAService: 'Book a service!',
      date: 'Date',
      price: 'Price',
      status: 'Status',
      totalPrice: 'Total Price',
      book: 'Confirm Booking',
      bookingSuccess: 'Booking confirmed successfully!',
      myBookings: 'My Bookings',
      currentBookings: 'Current Bookings',
      bookingHistory: 'Completed or Cancelled Bookings',
      noCurrentBookings: 'No current bookings.',
      noBookingHistory: 'No completed or cancelled bookings.',
      discountApplied: '{{percentage}}% discount applied',
      cleaningSummary: 'Cleaning summary',
      estimatedDuration: 'Estimated duration'
    },
    auth: {
      login: 'Login',
      signup: 'Sign Up',
      email: 'Email',
      password: 'Password',
      passwordHelp: 'Use at least 8 characters',
      name: 'Full Name',
      signInGoogle: 'Sign in with Google',
      getStarted: 'Get Started',
      dontHaveAccount: "Don't have an account?",
      alreadyHaveAccount: 'Already have an account?',
      forgotPassword: 'Forgot password or username?',
      emailIsUsername: 'Your username is your email address. Enter it to receive a reset link.',
      sendResetLink: 'Send reset link',
      resetEmailSent: 'If this email is registered, a link has been sent.',
      resetEmailInstructions: 'If an account matches this address, you will receive a link valid for one hour. Please also check your spam folder.',
      resetRequestError: 'Unable to request a password reset',
      backToLogin: 'Back to login',
      createNewPassword: 'Create a new password',
      saveNewPassword: 'Save new password',
      passwordResetSuccess: 'Password reset successfully',
      resetPasswordError: 'Unable to reset password',
      invalidResetLink: 'This link is invalid or has expired.',
      requestNewLink: 'Request a new link'
    },
    profile: {
      title: 'My Profile',
      personalInformation: 'Personal Information',
      phone: 'Phone number',
      saveProfile: 'Save Profile',
      saved: 'Profile updated successfully',
      loadError: 'Failed to load profile',
      saveError: 'Failed to update profile',
      changePassword: 'Change Password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Confirm new password',
      updatePassword: 'Update Password',
      passwordMismatch: 'The new passwords do not match',
      passwordSaved: 'Password updated successfully',
      passwordError: 'Failed to update password'
    },
    admin: {
      dashboard: 'Admin Dashboard',
      bookingRequests: 'Booking Requests',
      filterByStatus: 'Filter by status',
      allStatuses: 'All statuses',
      bookingCount: '{{count}} booking(s)',
      noBookingsForStatus: 'No bookings were found with this status.',
      services: 'Rates',
      users: 'Users',
      registeredUsers: 'Registered Users',
      userCount: '{{count}} user(s)',
      noUsers: 'No registered users.',
      loadUsersError: 'Failed to load users',
      role: 'Role',
      accountStatus: 'Account Status',
      registeredAt: 'Registered On',
      active: 'Active',
      inactive: 'Inactive',
      roles: {
        customer: 'Customer',
        collaborator: 'Collaborator',
        admin: 'Administrator'
      },
      manageServices: 'Manage Rates',
      addService: 'Add Service',
      editRates: 'Edit rates',
      itemIcon: 'Icon',
      createGeneralCleaning: 'Prepare General Cleaning',
      editService: 'Edit Service',
      titleEn: 'Title (English)',
      titleFr: 'Title (French)',
      descriptionEn: 'Description (English)',
      descriptionFr: 'Description (French)',
      detailsEn: 'Details (English)',
      detailsFr: 'Details (French)',
      onePerLine: 'One detail per line',
      price: 'Price',
      durationHours: 'Base duration (hours)',
      enableConfigurator: 'Let customers choose rooms and options',
      configuratorHelp: 'Price and duration increase automatically with the selected quantities.',
      configurationItems: 'Configurable rooms and options',
      loadDefaultItems: 'Load the 12 default options',
      addConfigurationItem: 'Add option',
      itemNameEn: 'Name (English)',
      itemNameFr: 'Name (French)',
      defaultQuantity: 'Included quantity',
      additionalPrice: 'Price per additional unit',
      additionalMinutes: 'Minutes per additional unit',
      capacityPerSlot: 'Reservations accepted per time slot',
      affectsOtherServices: 'Share availability with other services',
      affectsOtherServicesHelp: 'When enabled, this service uses the same team as every other enabled service. Overlapping bookings block availability across the entire shared group.',
      sharedSchedule: 'Shared team schedule',
      perTimeSlot: 'per time slot',
      serviceSaved: 'Service saved successfully',
      serviceSaveError: 'Failed to save service',
      removeServiceConfirm: 'Remove this service?',
      serviceRemoved: 'Service removed successfully',
      serviceRemoveError: 'Failed to remove service',
      duplicate: 'Duplicate',
      serviceDuplicated: 'Service duplicated successfully',
      serviceDuplicateError: 'Failed to duplicate service',
      reorderService: 'Reorder service',
      moveUp: 'Move up',
      moveDown: 'Move down',
      serviceOrderUpdated: 'Service order updated',
      serviceOrderError: 'Failed to update service order',
      settings: 'Settings',
      workingHours: 'Working Hours',
      alertEmails: 'Alert Emails',
      availability: 'Availability',
      availableDates: 'Available Dates — Next 3 Months',
      availableDatesInfo: 'Each click reduces capacity from 2 to 1, then to 0 people. One more click returns it to 2 people. Save your changes afterward.',
      saveAvailableDates: 'Save Available Dates',
      availabilityUpdated: 'Available dates updated successfully',
      availabilityUpdateError: 'Unable to update available dates',
      configureDayHours: 'Set working hours for this weekday before opening this date.',
      confirmBooking: 'Confirm',
      rejectBooking: 'Reject',
      addEmail: 'Add Email',
      saveChanges: 'Save Changes',
      date: 'Date',
      service: 'Service',
      customer: 'Customer',
      address: 'Address',
      status: 'Status',
      actions: 'Actions',
      pending: 'Pending',
      confirmed: 'Confirmed',
      completed: 'Completed',
      cancelled: 'Cancelled',
      enterEmail: 'Enter email address',
      remove: 'Remove',
      closed: 'Closed',
      workingHoursInfo: 'Configure your working hours and availability in this section.',
      start: 'Start',
      end: 'End',
      saveWorkingHours: 'Save Working Hours',
      workingHoursUpdated: 'Working hours updated successfully',
      workingHoursUpdateError: 'Failed to update working hours',
      loadBookingsError: 'Failed to load bookings',
      loadSettingsError: 'Failed to load settings',
      bookingUpdated: 'Booking updated successfully',
      bookingUpdateError: 'Failed to update booking',
      approximateStartTime: 'Approximate start time',
      startTimeRequired: 'Enter the approximate start time before confirming.',
      assignedCollaborator: 'Collaborator', selectCollaborator: 'Select a collaborator', collaboratorRequired: 'Select an available collaborator before confirming.',
      twoPeople: '2 people available', onePerson: '1 person available', noPeople: 'No people available',
      roleUpdated: 'Role updated', roleUpdateError: 'Unable to update role', viewAvailability: 'View schedule',
      availabilityOf: '{{name}} availability', noAvailability: 'No availability saved.',
      deleteBookingConfirm: 'Permanently delete this booking request? This action cannot be undone.',
      bookingDeleted: 'Booking request deleted',
      bookingDeleteError: 'Failed to delete booking request',
      enterEmailError: 'Please enter an email',
      emailAdded: 'Alert email added',
      emailAddError: 'Failed to add email',
      emailRemoved: 'Alert email removed',
      emailRemoveError: 'Failed to remove email',
      days: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday'
      }
    },
    collaborator: {
      title: 'My Availability', instructions: 'Select your available days and hours for the next three months.',
      addDay: 'Make this day available', removeDay: 'Remove this day', save: 'Save my availability',
      saved: 'Availability saved', loadError: 'Unable to load availability', saveError: 'Unable to save availability'
    },
    icons: {
      basement: 'Basement', toilet: 'Toilet', bath: 'Bathroom', bed: 'Bed', kitchen: 'Kitchen',
      sofa: 'Sofa', dining: 'Dining room', stairs: 'Stairs', window: 'Window',
      oven: 'Oven', fridge: 'Refrigerator', cabinet: 'Cabinet', linen: 'Bed linen', sparkles: 'Other'
    },
    footer: {
      description: 'Professional cleaning services for a spotless home.',
      contact: 'Contact Us',
      email: 'Email',
      phone: 'Phone',
      rights: 'All rights reserved.'
    },
    contact: {
      title: 'Contact Us',
      address: 'Address (optional)',
      message: 'Message',
      send: 'Send',
      sent: 'Your message was sent successfully.',
      sendError: 'Unable to send your message. Please try again.',
      tooMany: 'Too many messages. Please try again later.'
    },
    common: {
      welcome: 'Welcome',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      save: 'Save',
      edit: 'Edit',
      delete: 'Delete',
      close: 'Close',
      select: 'Select',
      previousImage: 'Previous image',
      nextImage: 'Next image',
      chooseCarouselImage: 'Choose carousel image',
      showImage: 'Show image {{number}}',
      fillAllFields: 'Please fill in all fields',
      passwordMinLength: 'Password must contain at least 8 characters',
      enterName: 'Please enter your name',
      authenticationSuccess: 'Authentication successful!',
      signUpFailed: 'Sign up failed',
      loginFailed: 'Login failed'
    }
  }
};

export default en;
